import React from "react"
import { useSelector } from "react-redux"
import { isEqual } from "lodash-es"
import { formSubmissionAnswers, formSubmissionFlaggedQuestionUuids } from "reduxSlices/formSubmissionSlice"
import { useFormSubmissionFormContext } from "contexts/FormSubmissionFormContext"
import { AnsweredFormOverview } from "shared/form"

const SubmissionOverview = () => {
  const { submittedFormVersion } = useFormSubmissionFormContext()
  const { sections } = submittedFormVersion

  const answers = useSelector(formSubmissionAnswers, isEqual)
  const flaggedQuestionUuids = useSelector(formSubmissionFlaggedQuestionUuids, isEqual)

  return (
    <div className="relative">
      <AnsweredFormOverview
        answers={answers}
        flaggedQuestionUuids={flaggedQuestionUuids}
        sections={sections}
      />
    </div>
  )
}

export default SubmissionOverview
